
const digest = 'a2a1f8746b11b324ee36be44d3a796ee055791e30cea0ace75b0b41550b1012b';
const classes = {"inline":"_inline_1oqff_1"};
const css = `._inline_1oqff_1 {
  display: flex;
  flex-direction: row;
  gap: 10px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  